import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import javascriptImage from '../../images/cardpageimages/technicalcourse/javasctiptimage.png'
import IntroVideos from "../../componants/introvideos";
import JavaScriptModule from "../../componants/allCourseModule/TechnicalCourseModule/JavaScriptModule";
 
 export default function JavaScript() {
  return (
    <>
      <Header />
      <BannerForAll
        title="JAVASCRIPT FULL COURSE"
        text="Our JavaScript Full Course is designed to teach you the essentials of JavaScript, the language of the web. Covering fundamentals such as variables, functions, DOM manipulation, event handling, and asynchronous programming, this course is perfect for beginners looking to build interactive and dynamic web applications. Gain the skills needed to create web projects and advance in front-end development."
        imageone={javascriptImage}
        imagetwo={javascriptImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="JAVASCRIPT"
      />
      <JavaScriptModule />
      <Footer />
    </>
  );
}


